<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="share-dialog">
  <div class="share-dialog__header">
    <div class="share-dialog__icon-wrapper">
      <ptl-icon [icon]="Link04Icon" size="l"></ptl-icon>
    </div>
    <button
      class="share-dialog__close"
      type="button"
      (click)="closeDialog()"
      [attr.aria-label]="'translations.global.ariaLabels.close' | transloco"
    >
      <ptl-icon [icon]="Cancel01Icon" size="l"></ptl-icon>
    </button>
  </div>

  <h2 class="share-dialog__title">{{ 'translations.shareDialog.title' | transloco }}</h2>

  <p class="share-dialog__description">
    {{ 'translations.shareDialog.description' | transloco }}
  </p>

  <div class="share-dialog__url-section">
    <label class="share-dialog__label" for="shareUrlInput">{{ 'translations.shareDialog.urlLabel' | transloco }}</label>
    <div class="share-dialog__url-row">
      <input class="share-dialog__url-input" id="shareUrlInput" type="text" [value]="shareUrl" readonly />
      <button class="share-dialog__copy-btn" type="button" (click)="copyLink()">
        <ptl-icon [icon]="Copy01Icon" size="s"></ptl-icon>
        {{ 'translations.global.button.copy' | transloco }}
      </button>
    </div>
  </div>

  <div class="share-dialog__social-section">
    <span class="share-dialog__social-label">{{ 'translations.shareDialog.orShareWith' | transloco }}</span>
    <div class="share-dialog__social-icons">
      <button
        *ngFor="let item of socialShareItems"
        class="share-dialog__social-btn share-dialog__social-btn--{{ item.name }}"
        type="button"
        [attr.aria-label]="'translations.shareDialog.shareOn' | transloco: { platform: item.title }"
        (click)="shareAction(item.name)"
      >
        <img [src]="item.image" [alt]="item.title" class="share-dialog__social-img" />
      </button>
    </div>
  </div>
</div>
